<template>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-text-field v-bind="attrs" v-on="on"
          v-model="getMaxNoInputLocal"
          :label="inputLabel"
          :readonly="!inputFieldOverride || isNewItem"
          @dblclick.stop="overrideMaxNumber"
          color="red"
          type="number"
          :class="ReceiptPulseClass"
          :rules="rules"
        ></v-text-field>
      </template>
      <span>{{ inputHoverCaption }}</span>
    </v-tooltip>
  </template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'GetMaxInvestmentNumber',
  props: {
    fiscalYear: [Number, String],
    fieldType: {
      type: String,
      default: 'Item',
    },
    investmentId: [Number, String],
    isNewItem: Boolean,
    rules: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    inputFieldOverride: false,
  }),
  model: {
    prop: 'investmentId',
    event: 'maxNumberChg',
  },
  created() {
    this.loadLastInvestmentNo();
  },
  computed: {
    ...mapState({
      nextInvestmentNumber: (state) => state.glDaily.glInvestmentTransaction.nextInvestmentNumber,
      receiptPulse: (state) => state.glDaily.glInvestmentTransaction.receiptPulse,
    }),
    ...mapGetters('base/crud', [
      'item',
    ]),
    ReceiptPulseClass() {
      return this.receiptPulse ? 'color-anim-pulse' : 'color-anim-black';
    },
    inputLabel() {
      if (this.nextInvestmentNumber === undefined) {
        return `${this.fieldType}# (last: ...)`;
      }
      return `${this.fieldType}# (last: ${this.nextInvestmentNumber - 1})`;
    },
    getMaxNoInputLocal: {
      get() {
        return this.investmentId;
      },
      set(value) {
        this.$emit('maxNumberChg', value);
      },
    },
    inputHoverCaption() {
      if (this.isNewItem) {
        return `${this.fieldType}  must be saved before its number can be changed`;
      }
      return 'Double-click to override (use ⚠️ caution)';
    },
  },
  methods: {
    ...mapActions('glDaily/glInvestmentTransaction', [
      'loadLastInvestmentNo',
    ]),
    overrideMaxNumber() {
      if (!this.inputFieldOverride) {
        this.inputFieldOverride = true;
      }
    },
  },
};
</script>

<style>

</style>
